import { createListenerMiddleware } from '@reduxjs/toolkit';

import { washRuleConfigurationsApi } from '@/apps/common/settings/redux/washRuleConfigurationsApi';
import { washingApi } from '@/apps/washing/redux/washingApi';
import { currentUserPermissionsChanged } from '@/redux/actions';

/**
 * Keeps the washing app's monitored-depot options in step with a rule-config
 * save in settings.
 *
 * The two api slices live in different feature apps and must not import each
 * other, so the invalidation is wired here, in the shared store layer that
 * already owns both. The PUT itself only changes the four rule fields, so this
 * is a consistency measure rather than an enable/disable path — a depot that
 * disappears or reappears server-side is picked up on the next save instead of
 * waiting for a reload.
 */
export const washMonitoredDepotsListener = createListenerMiddleware();

washMonitoredDepotsListener.startListening({
  matcher:
    washRuleConfigurationsApi.endpoints.updateWashRuleConfiguration
      .matchFulfilled,
  effect: (_action, listenerApi) => {
    listenerApi.dispatch(washingApi.util.invalidateTags(['MonitoredDepots']));
  },
});

// The signed-in user's own contract grant just changed, and these reads are
// scoped by it server-side: refetch rather than keep showing depots and rows
// of a contract that may have been taken away.
washMonitoredDepotsListener.startListening({
  actionCreator: currentUserPermissionsChanged,
  effect: (_action, listenerApi) => {
    listenerApi.dispatch(
      washingApi.util.invalidateTags([
        'MonitoredDepots',
        'CleaningList',
        'WashHistory',
      ])
    );
  },
});

export default washMonitoredDepotsListener;
